// extracted by mini-css-extract-plugin
export var boxContainer = "ManageYourBoxBanner_boxContainer__poKnV";
export var boxName = "ManageYourBoxBanner_boxName__bXBsm";
export var disclaimer = "ManageYourBoxBanner_disclaimer__dbuVp";
export var image = "ManageYourBoxBanner_image__UBs6E";
export var imageContainer = "ManageYourBoxBanner_imageContainer__ehlHr";
export var nameAndLinkContainer = "ManageYourBoxBanner_nameAndLinkContainer__vHJaj";
export var prepaid = "ManageYourBoxBanner_prepaid__8DyRj";
export var prepaidContainer = "ManageYourBoxBanner_prepaidContainer__ln4td";